// extracted by mini-css-extract-plugin
export var bottomWave = "L_b5";
export var container = "L_b";
export var middleWave = "L_b4";
export var section = "L_j";
export var subtitle = "L_b7";
export var text = "L_bw";
export var textContainer = "L_b6";
export var title = "L_g";